import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { useSiteContent } from "@/lib/siteContent";

export default function InfoBanner() {
  const [open, setOpen] = useState(false);
  const b = useSiteContent()?.bant;
  if (!b || b.aktif === false || !b.metin) return null;
  return (
    <div className="sticky top-16 z-40 bg-white border-b border-slate-200" data-testid="info-banner">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 min-h-9 py-1.5 flex items-center justify-between gap-4">
        <p className="text-xs sm:text-[13px] text-slate-600 leading-snug">{b.metin}</p>
        {b.detay && (
          <button onClick={() => setOpen(!open)} aria-expanded={open} data-testid="info-banner-toggle"
            className="shrink-0 inline-flex items-center gap-0.5 text-xs sm:text-[13px] font-medium text-teal-700 hover:text-teal-800">
            Tedarik koşulları ›
            <ChevronDown className={`w-3.5 h-3.5 transition-transform ${open ? "rotate-180" : ""}`} />
          </button>
        )}
      </div>
      {open && (
        <div className="border-t border-slate-200 bg-slate-50" data-testid="info-banner-details">
          <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-4">
            <h3 className="font-head font-semibold text-slate-900 text-sm mb-2">{b.detay_baslik}</h3>
            <p className="text-sm text-slate-600 leading-relaxed max-w-3xl whitespace-pre-line">{b.detay}</p>
            <button onClick={() => setOpen(false)} data-testid="info-banner-close"
              className="mt-3 text-sm font-medium text-teal-700 hover:text-teal-800 border border-teal-200 rounded-md px-3 py-1.5 bg-white">
              Kapat
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
